import { render, staticRenderFns } from "./Module_management.vue?vue&type=template&id=29210181&style=height%3A100%25"
import script from "./Module_management.vue?vue&type=script&lang=js"
export * from "./Module_management.vue?vue&type=script&lang=js"
import style0 from "./Module_management.vue?vue&type=style&index=0&id=29210181&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports